import React, { FunctionComponent } from 'react';
import { Grid, Typography } from '@material-ui/core';
import customiseCategoryStyles from './customiseCategoryStyles';
import ICategory from '../../../../../model/ICategory';
import ComplexAccordion from '../../../../../../gqlCommon/components/presentation/genericAccordion/ComplexAccordion';
import CustomiseCheckboxOptionsList from '../customiseOptions/checkboxOption/CustomiseCheckboxOptionsList';

export interface ICustomiseCategoryProps {
  category: ICategory;
  id: number;
  expandedPanelId: string;
  setExpanded: (expanded: string) => void;
}

const CustomiseCategory: FunctionComponent<ICustomiseCategoryProps> = ({
  category,
  id,
  expandedPanelId,
  setExpanded,
}) => {
  const styles = customiseCategoryStyles();

  return (
    <ComplexAccordion
      id={id}
      expandedPanelId={expandedPanelId}
      setExpanded={setExpanded}
      summary={
        <Typography component={'p'} variant={'subtitle1'} data-test={`accordion:toggle:${category.name}`}>
          {category.name}
        </Typography>
      }
      details={
        <Grid style={{ width: '100%' }} data-test={`options:category:${category.name}`}>
          <CustomiseCheckboxOptionsList
            featuresList={category.featuresList}
            data-test={`options:category:${category.name}`}
          />
        </Grid>
      }
      classes={{
        accordionSummary: styles.accordionSummary,
      }}
      dataTest={`accordion:category:${category.name}`}
    />
  );
};

export default CustomiseCategory;
